import { create } from 'zustand';
import { TextData } from '../dto/EntityRepository';

/** 마퀴 선택 박스와 겹치는 Text (리스트 표시 순, DOM 순) */
interface TextListMarqueeState {
  hitTexts: TextData[];
  setHitTexts: (texts: TextData[]) => void;
  clearHitTexts: () => void;
}

function sameTextsByIdOrder(a: TextData[], b: TextData[]): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (String(a[i].id) !== String(b[i].id)) return false;
  }
  return true;
}

export const useTextListMarqueeStore = create<TextListMarqueeState>((set, get) => ({
  hitTexts: [],
  setHitTexts: (texts) => {
    const next = texts;
    if (sameTextsByIdOrder(next, get().hitTexts)) return;
    set({ hitTexts: next });
  },
  clearHitTexts: () => {
    if (get().hitTexts.length === 0) return;
    set({ hitTexts: [] });
  },
}));
